import React, { Component } from 'react';
import './types.css';
import { connect } from 'react-redux';
import ColorPickers from './ColorPickers';
import InputTypesList from './InputTypesList';
import ChooseBgButton from './ChooseBgButton';
import CreateButtons from './CreateButtons';
import { MODE } from '../../config/env';
import { BUILDER_TYPES, INPUT_TYPES, MODES } from '../../config/constants';
import { Api } from '../../api/api-routes';
import { showErrorAlert, showSuccessAlert } from '../../redux/actions/alert';
import { mapResultData } from './result-data.mapper';


class ToolBar extends Component {

    constructor(props) {
        super(props);

        this.isUpdateMode = 'UPDATE_FORM_CONFIG' in window;
        this.backgroundId = 'UPDATE_FORM_CONFIG' in window ? window.UPDATE_FORM_CONFIG.builderConfig.settings.backgroundPictureId : '';
        this.formId = window.UPDATE_FORM_CONFIG ? window.UPDATE_FORM_CONFIG.formId : '';
        this.isIframeMode = window.UPDATE_FORM_CONFIG ? window.UPDATE_FORM_CONFIG.isIframeMode === '1' : false;
    }

    state = {
        formSlug: window.UPDATE_FORM_CONFIG ? window.UPDATE_FORM_CONFIG.formSlug : '',
        loading: false,
        isIframeMode: window.UPDATE_FORM_CONFIG ? window.UPDATE_FORM_CONFIG.isIframeMode === '1' : false,
    };

    handleIframeModeChange = async (event) => {
        const value = event.target.checked;

        try {
            this.setState({ loading: true });

            const response = await Api.setIframeMode(this.formId, JSON.stringify({value: value}));

            if (response.status === 'error') {
                this.props.showErrorAlert(response.errorMessage);
            } else {
                this.props.showSuccessAlert('Iframe mode updated successfully');
                this.isIframeMode = value;
                this.setState({ isIframeMode: value });
            }
        } catch (error) {
            this.props.showErrorAlert(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    getPostDataIfValid = () => {

        const resultJson = mapResultData(this, false, this.props.typeIds, this.props.inputWithProps);

        let defaultPasswordIsValid = true;
        for (const el of resultJson.config.inputs) {
            if (el.type === INPUT_TYPES.PASSWORD && el.useDefaultPass && !el.value) {
                defaultPasswordIsValid = false;
                break;
            }
        }

        if (defaultPasswordIsValid) {
            return resultJson;
        } else {
            this.props.showErrorAlert('Fill default password');
            return null;
        }
    }

    createSuccessPage = async () => {
        const resultJson = mapResultData(this, true, this.props.typeIds, this.props.inputWithProps);

        if (resultJson && MODE === MODES.PROD) {
            try {
                this.setState({ loading: true });

                const postConfigRes = await Api.updateSuccessPageConfig(this.formId, JSON.stringify(resultJson));

                if (postConfigRes.status === 'error') {
                    this.props.showErrorAlert(postConfigRes.errorMessage);
                } else {
                    this.props.showSuccessAlert('Success page updated successfully');
                    setTimeout(_ => {
                        window.location.reload();
                    }, 1000);
                }
                this.setState({ loading: false });
            } catch (e) {
                this.props.showErrorAlert(e.message);
                this.setState({ loading: false });
            }
        }
    };

    createForm = async () => {
        const resultJson = this.getPostDataIfValid();
        // console.log('resultJson: ', resultJson);

        if (resultJson && MODE === MODES.PROD) {
            try {
                this.setState({ loading: true });

                let postConfigRes;
                if (this.isUpdateMode) {
                    postConfigRes = await Api.updateFormConfig(this.formId, JSON.stringify(resultJson));
                } else {
                    postConfigRes = await Api.saveFormConfig(JSON.stringify(resultJson));
                }

                if (postConfigRes.status === 'error') {
                    this.props.showErrorAlert(postConfigRes.errorMessage);
                } else {
                    this.props.showSuccessAlert('Form ' + (this.isUpdateMode ? 'updated' : 'created') + ' successfully');

                    let formId = this.formId;
                    if (postConfigRes.data && postConfigRes.data.formId) {
                        formId = postConfigRes.data.formId;
                    }
                    setTimeout(_ => {
                        if (this.isUpdateMode) {
                            window.location.reload();
                        } else {
                            window.location.replace('/form/' + formId + '/edit');
                        }
                    }, 1000);
                }
                this.setState({ loading: false });
            } catch (e) {
                this.props.showErrorAlert(e.message);
                this.setState({ loading: false });
            }
        }
    };

    updateBackgroundId = (backgroundId) => {
        this.backgroundId = backgroundId;
    };

    render() {
        return (
            <div className="outer-container">
                <div className="inner-container">
                    <InputTypesList />
                </div>

                <div className="inner-container">
                    <ColorPickers />

                    {
                        this.props.activeBuilderType === BUILDER_TYPES.FORM &&
                        <ChooseBgButton
                            updateBackgroundId={this.updateBackgroundId}
                        />
                    }
                </div>

                {
                    this.props.activeBuilderType === BUILDER_TYPES.FORM &&
                    <div className="inner-container">
                        <label>
                            <input
                                value={this.state.formSlug}
                                onChange={(e) => this.setState({ formSlug: e.target.value })}
                                type="text"
                                placeholder="Type form id"
                            />
                        </label>
                    </div>
                }

                {this.props.activeBuilderType === BUILDER_TYPES.FORM && (
                    <div className="inner-container">
                        <label>
                            <input
                                type="checkbox"
                                checked={this.state.isIframeMode}
                                onChange={this.handleIframeModeChange}
                            />
                            Is iframe form
                        </label>
                    </div>
                )}

                <div className="inner-container">
                    <CreateButtons
                        loading={this.state.loading}
                        activeBuilderType={this.props.activeBuilderType}
                        createForm={this.createForm}
                        createSuccessPage={this.createSuccessPage}
                    />
                </div>
            </div>
        );
    }
}


export default connect(
    state => ({
        terms: state.terms,
        colors: state.colors,
        activeBuilderType: state.activeBuilderType,
        typeIds: state.typeId,
        inputWithProps: state.inputWithProps,
    }),
    {
        showErrorAlert,
        showSuccessAlert
    }
  )(ToolBar);



